import React from 'react'
import PropTypes from 'prop-types'

import './ConfigProductItemTitle.scss'

const DosageConfig = ({name, description, quantityTitle}) => (


    <div className="config-product-item-title_config" >
    <h1 className="config-product-item-title_config--name">{name}</h1>
    <p style={{fontSize:18, fontWeight: 'bold'}}className={`${quantityTitle ? 'config-product-item-title_config--quantity': 'config-product-item-title_config--description'}`}>{description}</p>
  </div>
  


)

DosageConfig.propTypes = {
  name: PropTypes.string.isRequired, 
  description: PropTypes.string, 
  quantityTitle: PropTypes.string
}

DosageConfig.defaultProps = {
  description: '', 
  quantityTitle: ''
}


export default DosageConfig